import React from 'react';
import loadable from '@loadable/component';
import { Switch, Route } from 'react-router-dom';

import { PAGE_URLS } from 'AppConstants';

const MicePage = loadable(() => import('./pages/mice'));

const VenuesPage = loadable(() => import('./pages/venues'));

const App = (props) => (
	<Switch>
		<Route path={PAGE_URLS.VENUES}>
			<VenuesPage {...props} />
		</Route>
		<Route path={PAGE_URLS.MICE_PAGES}>
			<MicePage {...props} />
		</Route>

	</Switch>

);

export default App;
